import { DarkButton, LightButton, MainContainer } from "components/common";
import {
  CustomDropdown,
  DrawerDiv,
  DropdownItem,
  LaunchBtn,
  LaunchBtns,
  MainSection,
  Text,
  Title,
} from "./elements";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../../../assets/images/logo2.png";
import React, { useState, useRef, useEffect } from "react";

const NavbarComp = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 1000) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setDropdownVisible(false);
    }, 300);
  };

  const handleDropdownClick = () => {
    if (isDropdownVisible) {
      setDropdownVisible(false);
    } else {
      setDropdownVisible(true);
    }
  };

  const isMobile = () => {
    const mobileWidth = 991.98;
    return window.innerWidth <= mobileWidth;
  };

  useEffect(() => {
    const handleWindowResize = () => {
      if (!isMobile()) {
        setDropdownVisible(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <MainSection>
      <Navbar
        expand="lg"
        fixed="top"
        className={scrolled ? "new-navbar" : "navbar"}
      >
        <MainContainer>
          <Navbar.Brand href="#home">
            <img src={logo} width={45} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="m-auto">
              <Nav.Link href="#home" className={scrolled && "updatedlinks"}>
                Home
              </Nav.Link>
              <Nav.Link href="#about" className={scrolled && "updatedlinks"}>
                About
              </Nav.Link>

              <div className="features-div">
                <Nav.Link
                  className={scrolled && "updatedlinks"}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  ref={dropdownRef}
                  onClick={isMobile() ? handleDropdownClick : undefined}
                >
                  Features
                </Nav.Link>

                {isDropdownVisible && (
                  <CustomDropdown
                    onClick={handleDropdownClick}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <DropdownItem>Cross-chain swap</DropdownItem>
                    <DropdownItem> NFT Aggregrator</DropdownItem>
                    <DropdownItem> Card Solutions</DropdownItem>
                    <DropdownItem> Payment Solutions</DropdownItem>
                    <DropdownItem> Earn & Reward Solutions</DropdownItem>
                    <DropdownItem> Staking Vault</DropdownItem>
                  </CustomDropdown>
                )}
              </div>

              <Nav.Link
                href="#tokennomics"
                className={scrolled && "updatedlinks"}
              >
                Tokenomics
              </Nav.Link>
              <Nav.Link
                href="#whitepaper"
                className={scrolled && "updatedlinks"}
              >
                Whitepaper
              </Nav.Link>
              <Nav.Link href="#roadmap" className={scrolled && "updatedlinks"}>
                Roadmap
              </Nav.Link>
              <Nav.Link href="#docs" className={scrolled && "updatedlinks"}>
                Docs
              </Nav.Link>
              <Nav.Link href="#faq" className={scrolled && "updatedlinks"}>
                FAQ’s
              </Nav.Link>
            </Nav>
            {scrolled ? (
              <DarkButton btnText="Pre-Sale" />
            ) : (
              <LightButton btnText="Pre-Sale" />
            )}
          </Navbar.Collapse>
        </MainContainer>
      </Navbar>
    </MainSection>
  );
};

export default NavbarComp;
